export const ADMIN_USER_STATUS = {
  ACTIVE: "active",
  INACTIVE: "inactive",
} as const;

export const isActiveAdminUser = (status?: string | null) =>
  status?.toLowerCase() === ADMIN_USER_STATUS.ACTIVE;

export const getAdminUserToggleStatus = (status?: string | null) =>
  isActiveAdminUser(status)
    ? ADMIN_USER_STATUS.INACTIVE
    : ADMIN_USER_STATUS.ACTIVE;

export const ADMIN_USER_STATUS_BADGE: Record<string, string> = {
  [ADMIN_USER_STATUS.ACTIVE]: "light-success",
  [ADMIN_USER_STATUS.INACTIVE]: "light-warning",
};

export const ADMIN_USER_STATUS_OPTIONS = [
  { value: "", label: "All Status" },
  { value: ADMIN_USER_STATUS.ACTIVE, label: "Active" },
  { value: ADMIN_USER_STATUS.INACTIVE, label: "Inactive" },
];

export const ADMIN_USERS_LIST_PATH = "/apps/user/admin-users";
export const getAdminUserViewPath = (id: string | number) =>
  `${ADMIN_USERS_LIST_PATH}/view/${id}`;
